import React, { useState } from "react"

import { Translate } from "../../Components/Translator"

const EmbeddedSalesforceSettings = (props) => {

    const [mRepainter, SetRepainter] = useState(0)

    return (
        <>
            <tr className="usersettings" height="20"/>
            <tr className="foregroundlightasbackground">
                <td colSpan="2" align="center"><b>Salesforce</b></td>
            </tr>
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Softphone layout")}</td>
                <td width="*" valign="center">
                    {Translate("This app uses the Softphone Layout settings defined in Salesforce")}
                </td>
            </tr>
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Call registration")}</td>
                <td width="*" valign="center">
                    {Translate("Default subject inbound calls")}<br/>
                    <textarea style={{ width: '100%', height: '50px', padding: '6px' }} value={localStorage.getItem("sforce_setting_defaultcallsubjectinbound")} placeholder={localStorage.getItem("sforce_callcenter_defaultcallsubjectinbound")} onChange={(evt) => { localStorage.setItem("sforce_setting_defaultcallsubjectinbound", evt.target.value); SetRepainter(mRepainter+1)}}/><br/>
                    <br/>
                    {Translate("Default subject outbound calls")}<br/>
                    <textarea style={{ width: '100%', height: '50px', padding: '6px' }} value={localStorage.getItem("sforce_setting_defaultcallsubjectoutbound")} placeholder={localStorage.getItem("sforce_callcenter_defaultcallsubjectoutbound")} onChange={(evt) => { localStorage.setItem("sforce_setting_defaultcallsubjectoutbound", evt.target.value); SetRepainter(mRepainter+1)}}/><br/>
                </td>
            </tr>
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Automatic actions")}</td>
                <td width="*" valign="center">
                    {Translate("What actions should be automatically performed?")}<br/>
                    <br/>
                    <input type="checkbox" style={{ paddingLeft: "2px" }} onChange={(evt) => { localStorage.setItem("sforce_setting_showphone", evt.target.checked ? "1" : "0"); SetRepainter(mRepainter+1)}} checked={localStorage.getItem("sforce_setting_showphone") === "1"}/> {Translate("Show softphone")}<br/>
                    <input type="checkbox" style={{ paddingLeft: "2px" }} onChange={(evt) => { localStorage.setItem("sforce_setting_registercall", evt.target.checked ? "1" : "0"); SetRepainter(mRepainter+1)}} checked={localStorage.getItem("sforce_setting_registercall") === "1"}/> {Translate("Register call")} *<br/>
                    <br/>
                    <span className="smalltext">* {Translate("Only when there is a single-matching Salesforce record")}</span>                   
                </td>
            </tr>
        </>
    )
}

export default EmbeddedSalesforceSettings